/* tslint:disable */
/* eslint-disable */
export enum NameType {
  TWENTY_FIVE_PERCENT_BENEFICIAL_OWNER = 'TWENTY_FIVE_PERCENT_BENEFICIAL_OWNER'
}
